import ImageUploader from "../ImageUploader/ImageUploader";
import { Image } from "../../services/shirts/types";

interface ShirtImagesProps {
  addImage: Function;
  removeImage: Function;
  images: Array<Image>;
  error?: boolean;
}

const ShirtImages = ({
  addImage,
  removeImage,
  images,
  error,
}: ShirtImagesProps) => {
  return (
    <ImageUploader
      images={images}
      addImage={addImage}
      removeImage={removeImage}
      error={error}
    />
  );
};

export default ShirtImages;
